export const WHATSAPP_PHONE_EXAMPLE = "(11) 99999-9999";
export const WHATSAPP_PHONE_ERROR = `Informe DDD + número (10 ou 11 dígitos), com ou sem 55. Ex.: ${WHATSAPP_PHONE_EXAMPLE}.`;

// This is only an early UX guard. The backend remains the authoritative
// validation boundary and the worker validates its protected direct route too.
export function normalizeBrazilianWhatsAppPhone(value) {
  const raw = String(value || "").trim();
  if (!raw || !/^[\d\s()+-]+$/.test(raw)) return null;

  let digits = raw.replace(/\D/g, "");
  if ((digits.length === 12 || digits.length === 13) && digits.startsWith("55")) {
    digits = digits.slice(2);
  }
  if (!/^\d{10,11}$/.test(digits)) return null;

  const ddd = Number(digits.slice(0, 2));
  if (!Number.isInteger(ddd) || ddd < 11 || ddd > 99) return null;
  return `55${digits}`;
}
